module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-01-macbook-content.39726acd.png";